import LabelField from '@app/components/atoms/LabelField/LabelField'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { useTranslation } from 'react-i18next'

const LimitSection = ({ register, errors, trigger }) => {
  const { t } = useTranslation()
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <LabelField required title={t('CAMPAIGN.LIMIT_CODE_USER_PER_DAY')}>
          <TextField
            fullWidth
            name="codes_per_day"
            size="small"
            type="number"
            variant="outlined"
            {...register('codes_per_day')}
            error={errors.codes_per_day ? true : false}
            helperText={errors.codes_per_day?.message}
            onFocus={() => trigger('codes_per_day')}
          />
        </LabelField>
      </Grid>
      <Grid item xs={12}>
        <LabelField required title={t('CAMPAIGN.TIME_BETWEEN_REDEEM_CODE')}>
          <TextField
            fullWidth
            name="time_between_redeem"
            size="small"
            type="number"
            variant="outlined"
            {...register('time_between_redeem')}
            error={errors.time_between_redeem ? true : false}
            helperText={errors.time_between_redeem?.message}
            onFocus={() => trigger('time_between_redeem')}
          />
        </LabelField>
      </Grid>
    </Grid>
  )
}
export default LimitSection
